import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { ConsolidationSummaryType } from '@/features/dashboard/types';

async function getConsolidationSummaryInadimplenciaEvolucao(params): Promise<ConsolidationSummaryType> {
  const api = await getApi();
  const { data } = await api.get<ConsolidationSummaryType>('/inadimplencia/get_evolution_inadimplance/', { params });
  return data;
}

type QueryFnType = typeof getConsolidationSummaryInadimplenciaEvolucao;

function useConsolidationSummaryInadimplenciaEvolucao(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-consolidation-summary', params],
    queryFn: () => getConsolidationSummaryInadimplenciaEvolucao(params),
  });
}

export { getConsolidationSummaryInadimplenciaEvolucao, useConsolidationSummaryInadimplenciaEvolucao };
